"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Geocoding_1 = __importDefault(require("./Entity/Geocoding"));
var GeocodingApi = /** @class */ (function () {
    function GeocodingApi(session) {
        this.geocodingEntity = new Geocoding_1.default(session);
    }
    GeocodingApi.prototype.autoComplete = function (address) {
        return this.geocodingEntity.autoComplete(address);
    };
    GeocodingApi.prototype.getPlaceDetails = function (placeId) {
        return this.geocodingEntity.getPlaceDetails(placeId);
    };
    GeocodingApi.prototype.reverseGeocode = function (lat, lng) {
        return this.geocodingEntity.reverseGeocode(lat, lng);
    };
    return GeocodingApi;
}());
exports.default = GeocodingApi;
//# sourceMappingURL=GeocodingApi.js.map